export default function () {
  return {
    isSavingCareMediation: false,
  };
}
